<script setup>

import {onMounted, reactive, watch} from "vue";

const props = defineProps({
  status: String,
  invoiceNum: String,
  updateNum: Number
});

const emit = defineEmits(['closed', 'saved']);

const data = reactive({
  note: '',
  dialog: true
});

const close = () => {
  emit('closed');
}

const save = () => {
  emit('saved', data.note);
}

watch(() => props.updateNum, async (val) => {
  data.note = '';
});

onMounted(async ()=>{
});

</script>

<template>
  <div class="text-center">
    <v-dialog
        v-model="data.dialog"
        max-width="600"
        persistent
        v-if="props.status === 'open'"
        @click:outside="close"
    >
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>Add Collection Note - {{ props.invoiceNum }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12">
              <v-textarea label="Collection Note" v-model.lazy="data.note"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              text="Close"
              variant="plain"
              @click="close"
          ></v-btn>

          <v-btn
              color="primary"
              text="Add Note"
              variant="tonal"
              @click="save"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>

.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}

</style>